import { useState, useEffect, useCallback } from 'react';
import { getJobCharges } from '../api/jobCharges';
import type { JobCharge } from '../types/jobCharge';

/**
 * Hook for fetching job charges
 */
export function useJobCharges(jobId: number | undefined, isForecast?: boolean) {
  const [data, setData] = useState<JobCharge[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCharges = useCallback(async () => {
    if (!jobId) {
      setData([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError(null);
    try {
      const charges = await getJobCharges(jobId, isForecast);
      setData(charges);
    } catch (err) {
      const error = err as { response?: { data?: { message?: string } } };
      setError(error.response?.data?.message || 'Failed to fetch job charges');
      setData([]);
    } finally {
      setIsLoading(false);
    }
  }, [jobId, isForecast]);

  useEffect(() => {
    fetchCharges();
  }, [fetchCharges]);

  return {
    data,
    isLoading,
    error,
    refetch: fetchCharges,
  };
}
